import type { DatePickerTruncationUnit } from "metabase/querying/common/types";

export const UNIT_GROUPS: DatePickerTruncationUnit[][] = [
  ["day", "week", "month"],
  ["quarter", "year"],
];
